import { isImageVariable, isTextVariable } from '@carboncopyco/editor-utils';
import { VariableIcon } from '@carboncopyco/icons';
import type { IVariable } from '@carboncopyco/types';
import {
  MenuItem,
  TextBase,
  TextCaption,
  menuItemBackgroundColor,
  menuItemTextColor,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import { RuleIcon } from '../RuleIcon';
import { RulePreview } from '../RulePreview';

export interface SearchItemsProps<T extends IVariable> {
  variables: T[];
  onSelect: (variable: T) => void;
}

export const SearchItems = <T extends IVariable>({
  variables,
  onSelect,
}: SearchItemsProps<T>) => {
  if (!variables.length) {
    return (
      <div className="flex justify-center w-full py-2.5">
        <TextCaption
          label="Nothing match your search"
          color="text-ds-natural-400"
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1 max-h-[196px] overflow-auto">
      {variables.map((variable) => {
        return (
          <MenuItem
            key={isTextVariable(variable) ? variable.code : variable.variableId}
            item={{
              id: variable.variableId,
              label: variable.name,
            }}
            onSelect={() => onSelect(variable)}
            renderItem={(_, state) => {
              return (
                <div
                  className={classNames(
                    'rounded px-2.5 py-2 w-full cursor-pointer',
                    menuItemTextColor[state],
                    menuItemBackgroundColor[state]
                  )}
                >
                  <div className="w-full flex justify-between">
                    <RulePreview>
                      <RuleIcon size="sm">
                        <VariableIcon size={12} />
                      </RuleIcon>
                      <RulePreview.Tooltip title={variable.name}>
                        <div className="flex truncate max-w-[200px]">
                          <TextBase
                            label={variable.name}
                            color="text-ds-natural-600"
                          />
                        </div>
                      </RulePreview.Tooltip>
                    </RulePreview>
                    {isImageVariable(variable) && (
                      <RuleIcon
                        backgroundImageUrl={variable.value}
                        size="sm"
                      />
                    )}
                  </div>
                </div>
              );
            }}
          />
        );
      })}
    </div>
  );
};
